import type { Device } from './device'

export enum AssigneeTypeEnum {
  practitioner = 'practitioner',
  patient = 'patient',
}

/**
 * Information about the assignment of a device to a patient.
 */
export type DeviceAssignment = {
  /**
   * The UUID of the assignment.
   */
  id: string
  /**
   * The revision id.
   */
  revision: string

  createdAt: string
  updatedAt: string
  startedAt: string
  endedAt: string
  assigneeType: AssigneeTypeEnum
  assigneeId: string
  episodeOfCareId: string
  device: Device
  /**
   * The UUID of the assigned device.
   */
  deviceId: string

  /**
   * The UUID of the patient to which the device is assigned.
   */
  patientId: string
  expiresAt?: string
}
export type CreateDeviceAssignment = {
  assigneeType: AssigneeTypeEnum
  startedAt: string
  expiresAt?: string
  assigneeId: string
  episodeOfCareId: string
  deviceId: string
}
